import { ACTION_TYPES } from 'lib/Constants'

const {
    CLEAR_NOTE_HISTORY,
    CLEAR_NOTE_HISTORY_ERROR,
    LOAD_NOTE_HISTORY_REQUEST,
    LOAD_NOTE_HISTORY_SUCCESS,
    LOAD_NOTE_HISTORY_FAILURE
} = ACTION_TYPES

export default {
    CLEAR: CLEAR_NOTE_HISTORY,
    CLEAR_ERROR: CLEAR_NOTE_HISTORY_ERROR,
    LOAD_REQUEST: LOAD_NOTE_HISTORY_REQUEST,
    LOAD_SUCCESS: LOAD_NOTE_HISTORY_SUCCESS,
    LOAD_FAILURE: LOAD_NOTE_HISTORY_FAILURE
}